import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import { Spinner } from "@/components/kit";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import Holdings from "@/pages/Holdings";
import HoldingDetail from "@/pages/HoldingDetail";
import TxnWizard from "@/pages/TxnWizard";
import SettlementForm from "@/pages/SettlementForm";
import TxnDetail from "@/pages/TxnDetail";
import SettlementDetail from "@/pages/SettlementDetail";
import Ledger from "@/pages/Ledger";
import Profile from "@/pages/Profile";
import PersonProfile from "@/pages/PersonProfile";
import Search from "@/pages/Search";
import Activity from "@/pages/Activity";
import Pending from "@/pages/Pending";

function Protected() {
  const { auth } = useAuth();
  if (auth === null) return <Spinner />;
  if (!auth) return <Navigate to="/login" replace />;
  if (!auth.groups?.length) return <div className="p-8 text-center">No group access for this account.</div>;
  return <AppShell />;
}

function PublicOnly({ children }) {
  const { auth } = useAuth();
  if (auth === null) return <Spinner />;
  return auth ? <Navigate to="/" replace /> : children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route element={<Protected />}>
            <Route path="/" element={<Home />} />
            <Route path="/holdings" element={<Holdings />} />
            <Route path="/holding/:id" element={<HoldingDetail />} />
            <Route path="/add/settlement" element={<SettlementForm />} />
            <Route path="/add/:category" element={<TxnWizard />} />
            <Route path="/txn/:id" element={<TxnDetail />} />
            <Route path="/settlement/:id" element={<SettlementDetail />} />
            <Route path="/ledger" element={<Ledger />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/person/:id" element={<PersonProfile />} />
            <Route path="/search" element={<Search />} />
            <Route path="/activity" element={<Activity />} />
            <Route path="/pending" element={<Pending />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}
